/* Annie's Sweets & Treats — homepage interactions (Shopify port, vanilla JS, idempotent per section) */
(function () {
  'use strict';
  if (window.__ahHomeLoaded) return;
  window.__ahHomeLoaded = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const inEditor = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- Scroll reveals ---------- */
  let io = null;
  if ('IntersectionObserver' in window && !reduce && !inEditor) {
    io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('ah-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  }
  function observeReveals(root) {
    root.querySelectorAll('.ah-reveal').forEach((el) => {
      if (io) io.observe(el); else el.classList.add('ah-in');
    });
  }

  /* ---------- Hotspot anatomy ("Everything's inside") ---------- */
  function initHotspots(root) {
    const list = root.querySelector('[data-ah-hotspot-list]');
    const stage = root.querySelector('[data-ah-hotspot-stage]');
    if (!list || !stage || list.dataset.ahReady) return;
    list.dataset.ahReady = '1';
    const buttons = list.querySelectorAll('button[data-spot]');
    const spots = stage.querySelectorAll('.ah-spot[data-spot]');
    const card = stage.querySelector('[data-ah-spot-card]');
    const cNum = card && card.querySelector('[data-ah-spot-card-num]');
    const cTitle = card && card.querySelector('[data-ah-spot-card-title]');
    const cText = card && card.querySelector('[data-ah-spot-card-text]');
    let swapTimer;
    function activate(id) {
      buttons.forEach((b) => b.classList.toggle('ah-is-active', b.dataset.spot === id));
      spots.forEach((s) => s.classList.toggle('ah-is-active', s.dataset.spot === id));
      const src = list.querySelector('button[data-spot="' + id + '"]');
      if (card && src) {
        card.classList.add('ah-swap');
        clearTimeout(swapTimer);
        swapTimer = setTimeout(() => {
          if (cNum) cNum.textContent = src.querySelector('.ah-num').textContent;
          if (cTitle) cTitle.textContent = src.querySelector('b').textContent;
          if (cText) cText.textContent = src.querySelector('small').textContent;
          card.classList.remove('ah-swap');
        }, reduce ? 0 : 180);
      }
    }
    buttons.forEach((b) => ['mouseenter', 'focus', 'click'].forEach((ev) => b.addEventListener(ev, () => activate(b.dataset.spot))));
    spots.forEach((s) => ['mouseenter', 'click'].forEach((ev) => s.addEventListener(ev, () => activate(s.dataset.spot))));
  }

  /* ---------- Pinned steps ---------- */
  function initSteps(root) {
    const pin = root.querySelector('.ah-steps__pin');
    const stepsList = root.querySelector('[data-ah-steps]');
    const media = root.querySelector('[data-ah-steps-media]');
    if (!stepsList || stepsList.dataset.ahReady) return;
    stepsList.dataset.ahReady = '1';
    const items = stepsList.querySelectorAll('li[data-step]');
    const imgs = media ? media.querySelectorAll('img') : [];
    const dots = root.querySelectorAll('.ah-steps__dots i');
    const n = items.length;
    if (!pin || !media || reduce || inEditor || n === 0) {
      items.forEach((li) => li.classList.add('ah-is-active'));
      if (imgs[0]) imgs[0].classList.add('ah-is-active');
      return;
    }
    let current = -1;
    function setStep(i) {
      if (i === current) return;
      current = i;
      items.forEach((li, k) => li.classList.toggle('ah-is-active', k === i));
      imgs.forEach((im, k) => im.classList.toggle('ah-is-active', k === i));
      dots.forEach((d, k) => d.classList.toggle('ah-is-active', k === i));
    }
    function update() {
      const top = pin.getBoundingClientRect().top + window.scrollY;
      const range = pin.offsetHeight - window.innerHeight;
      const p = Math.min(1, Math.max(0, (window.scrollY - top) / Math.max(1, range)));
      setStep(Math.min(n - 1, Math.floor(p * n)));
    }
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(() => { update(); ticking = false; }); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
    items.forEach((li, k) => {
      li.addEventListener('click', () => {
        const top = pin.getBoundingClientRect().top + window.scrollY;
        const range = pin.offsetHeight - window.innerHeight;
        window.scrollTo({ top: top + range * ((k + 0.5) / n), behavior: 'smooth' });
      });
    });
  }

  /* ---------- Add to bag → real /cart/add.js, hands the response to Spotlight's cart drawer ---------- */
  let toastTimer;
  function toast(msg) {
    const t = document.querySelector('[data-ah-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('ah-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('ah-show'), 2600);
  }
  function initCartForms(root) {
    root.querySelectorAll('form[data-ah-add]').forEach((form) => {
      if (form.dataset.ahReady) return;
      form.dataset.ahReady = '1';
      form.addEventListener('submit', (evt) => {
        evt.preventDefault();
        const btn = form.querySelector('[type=submit]');
        const name = form.dataset.name || 'Item';
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const fd = new FormData(form);
        if (cart && typeof cart.getSectionsToRender === 'function') {
          fd.append('sections', cart.getSectionsToRender().map((s) => s.id).join(','));
          fd.append('sections_url', window.location.pathname);
        }
        if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: fd
        }).then((r) => r.json()).then((res) => {
          if (res.status) { toast(res.description || res.message || 'Sorry, that could not be added.'); return; }
          if (cart && typeof cart.renderContents === 'function' && res.sections) {
            try { cart.renderContents(res); } catch (e) { toast(name + ' added to your bag'); }
          } else {
            toast(name + ' added to your bag');
            if (res.sections && res.sections['cart-icon-bubble']) {
              const bubble = document.getElementById('cart-icon-bubble');
              if (bubble) {
                const html = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
                const inner = html.querySelector('.shopify-section');
                if (inner) bubble.innerHTML = inner.innerHTML;
              }
            }
          }
          document.dispatchEvent(new CustomEvent('cart:add', { detail: { id: fd.get('id'), qty: 1, source: 'ah-home' } }));
          if (window.publish && window.PUB_SUB_EVENTS) {
            try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: fd.get('id'), cartData: res }); } catch (e) {}
          }
        }).catch(() => { form.removeAttribute('data-ah-ready'); form.submit(); })
          .finally(() => { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
      });
    });
  }

  function init(root) {
    observeReveals(root);
    initHotspots(root);
    initSteps(root);
    initCartForms(root);
  }
  init(document);

  /* Theme editor: re-run when a section is (re)loaded */
  document.addEventListener('shopify:section:load', (e) => { init(e.target); e.target.querySelectorAll('.ah-reveal').forEach((el) => el.classList.add('ah-in')); });
  if (inEditor) document.querySelectorAll('.ah-reveal').forEach((el) => el.classList.add('ah-in'));
})();
